<template>
  <div class="row">
    <div class="col-xl-12">
      <router-view />

      <div
        v-show="$route.path == '/Marketing/MarketingList'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-poll"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    id="keySearch"
                    name="keySearch"
                    v-model="keySearch"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจากชื่อกิจกรรม หรือชื่อร้านค้า"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>ประเภทกิจกรรม :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'objectives'"
                    :name="'objectives'"
                    :select2-options="objectivesOptions"
                    v-model="objectives"
                    ref="objectivesSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'mktStatus'"
                    :name="'mktStatus'"
                    :select2-options="mktStatusOptions"
                    v-model="mktStatus"
                    ref="mktStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="marketingTable"
              >
                <thead>
                  <tr>
                    <th class="all">ประเภทกิจกรรม</th>
                    <th class="all">ชื่อกิจกรรม</th>
                    <th class="all">ตัวเทนจำหน่าย</th>
                    <th class="all">จังหวัด</th>
                    <th class="all">ชื่อร้านค้า</th>
                    <th class="all">ชื่อร้านค้า 2</th>
                    <th class="all">วันที่</th>
                    <th class="all">วันที่เริ่มต้น</th>
                    <th class="all">วันที่สิ้นสุด</th>
                    <th class="all">วันที่สร้าง</th>
                    <th class="all">สถานะ</th>
                    <th class="all">จัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import select2 from "../../Shared/Select2";
import router from "../../router";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let ActionsCanceled = Vue.extend({
  template: `
  <div>
    <a  v-if="data.showEditStatusButton"  class="btn btn-sm btn-danger " style="color:white;width: 80%;">
      ยกเลิก
    </a>
  </div>`,
});
let ActionsSaved = Vue.extend({
  template: `
  <div>
    <a  v-if="data.showEditStatusButton"  class="btn btn-sm btn-warning " style="color:white;width: 80%;">
      เปิด
    </a>
  </div>`,
});

let ActionsComplete = Vue.extend({
  template: `
  <div>
    <a  v-if="data.showEditStatusButton"  class="btn btn-sm btn-success  " style="color:white;width: 80%;">
      ปิด
    </a>
  </div>`,
});

let mktActions = Vue.extend({
  template: `
  <div>
    <a  href="#"  :id ='data.activityHeaderId' @contextmenu="handler(data.activityHeaderId)" @click.prevent="detailMkt"  v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-file-text"></i>
    </a>
    <a  href="#"  @click.prevent="closeMkt"  v-if="data.showCloseButton" title="ปิดใบงาน" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-archive"></i>
    </a>
    <a href="#" @click.prevent="detailAprroveMkt" v-if="data.isRequestChange" title="ขอแก้ไขพื้นที่" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
    
  </div>`,
  methods: {
    detailMkt: function() {
      router.push({
        path: `/Marketing/MarketingList/Detail/${this.data.activityHeaderId}`,
      });
    },
    detailAprroveMkt: function() {
      router.push({
        path: `/Marketing/ApproveDetail/${this.data.activityHeaderId}`,
      });
    },
    handler: function(e) {
      var name = this.data.activityHeaderId.toString();
      document.getElementById(
        name
      ).href = `/Marketing/MarketingList/Detail/${this.data.activityHeaderId}`;
    },
    closeMkt: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งปิดใบงาน",
        type: "warning",
        html: "กรุณายืนยันคำสั่งปิดใบงาน <strong>",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการปิดใบงาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่...",
          });

          axios
            .get("/Api/Marketing/CloseActivity/" + this.data.activityHeaderId)
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      keySearch: null,
      objectives: null,
      mktStatus: null,

      objectivesOptions: {
        placeholder: "กรุณาเลือกประเภทกิจกรรมที่ต้องการค้นหา",
        allowClear: true,
        ajax: {
          url: "/Api/Marketing/Select2Objectives",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      mktStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "MKT_ACTIVITY_STATUS_COMPLETE", text: "ปิด", data: null },
          { id: "MKT_ACTIVITY_STATUS_SAVED", text: "เปิด", data: null },
          { id: "MKT_ACTIVITY_STATUS_CANCELED", text: "ยกเลิก", data: null },
        ],
      },
    };
  },
  methods: {
    formReset: function(e) {
      let self = this;
      self.keySearch = null;
      self.objectives = null;
      self.mktStatus = null;

      $("#objectives")
        .val("")
        .trigger("change");

      $("#mktStatus")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#marketingTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#marketingTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
  },
  async mounted() {
    let self = this;

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#marketingTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Marketing/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                SearchKeyword: self.keySearch,
                Objectives: self.objectives,
                StatusCode: self.mktStatus,
              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[9, "desc"]],
        columns: [
          {
            data: "objectives",
            width: "10%",
            className: "text-center",
          },
          {
            data: "activityName",
            className: "text-center",
            width: "10%",
          },
          {
            data: "agentName",
            className: "text-center",
            width: "10%",
          },
          {
            data: "provinceName",
            className: "text-center",
            width: "10%",
          },
          {
            data: "shopName",
            className: "text-center",
            width: "10%",
          },
          {
            data: "shopName2",
            className: "text-center",
            width: "10%",
          },
          {
            data: "activityDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.activityDateString;
            },
          },
          {
            data: "activityDateStart",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.activityDateStartString;
            },
          },
          {
            data: "activityDateEnd",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.activityDateEndString;
            },
          },
          {
            data: "createDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.createDateString;
            },
          },
          {
            data: "statusCode",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "activityHeaderId",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGER_MKT",
              "ADMIN_MKT",
            ]);
            if (data.statusCode == "เปิด")
              new ActionsSaved({ data: { data }, parent: self }).$mount(el);
            else if (data.statusCode == "ปิด")
              new ActionsComplete({ data: { data }, parent: self }).$mount(el);
            else if (data.statusCode == "ยกเลิก")
              new ActionsCanceled({ data: { data }, parent: self }).$mount(el);
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          var listCanClose = [
            "MKT_ACTIVITY_TYPE_EVENT",
            "MKT_ACTIVITY_TYPE_FOOD_FESTIVAL",
          ];
          if (data) {
            data.showDetailButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGER_MKT",
              "ADMIN_MKT",
            ]);
            data.showCloseButton =
              data.statusCode == "เปิด" &&
              listCanClose.includes(data.objectivesCode) &&
              self.$root.canShow(["MANAGE_MASTER", "MANAGER_MKT", "ADMIN_MKT"]);
            // data.showDetailAprroveButton =
            new mktActions({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Marketing/MarketingList.vue